import React, { useCallback } from "react";
import { AddToChatButton } from "@components/tasks/AddToChatButton";
import { useAddCellsToChat } from "@components/tasks/useAddCellsToChat";

export const ProfitLossTaskCommandBar: React.FC = () => {
    const { pendingReference, addCellsToChat } = useAddCellsToChat();

    const handleAttach = useCallback(() => addCellsToChat(), [addCellsToChat]);

    if (!pendingReference) {
        return (
            <span className="text-sm text-gray-500">
                Select cells to add them to chat
            </span>
        );
    }

    return (
        <AddToChatButton
            key={pendingReference.rangeLabel}
            noun="cell"
            count={pendingReference.cells.length}
            detail={pendingReference.rangeLabel}
            onClick={handleAttach}
        />
    );
};
